// @ts-check

import { escapeRegExp } from 'lodash';

/**
 * Splits `value` into pieces on each match of `query`, in order, with each match marked.
 *
 * Matching:
 * - Case-insensitive, on the raw text.
 * - Literal: regex characters in the query match as themselves.
 * - A match keeps the text's own casing.
 *
 * `null` and `undefined` count as empty text, and an empty query matches nothing.
 *
 * @param {unknown} value
 * @param {unknown} query
 * @returns {{ text: string, isMatch: boolean }[]}
 */
export function splitMatches(value, query) {
  const text = value == null ? '' : String(value);
  const search = query == null ? '' : String(query);
  if (!search) {
    return [{ text, isMatch: false }];
  }

  // With a capture group, split puts the matches at the odd indexes.
  return text
    .split(new RegExp(`(${escapeRegExp(search)})`, 'gi'))
    .map((piece, index) => ({ text: piece, isMatch: index % 2 === 1 }));
}
